import { Button } from "@/components/ui/button";

export function ClientCertificateExpiryBanner({
  onOpenSettings,
}: {
  onOpenSettings?: () => void;
}) {
  return (
    <section
      role="alert"
      aria-labelledby="client-certificate-expired-title"
      className="mb-5 max-w-3xl rounded-md border border-red-300 bg-red-50 px-4 py-3 text-sm"
    >
      <p
        id="client-certificate-expired-title"
        className="font-semibold text-red-900"
      >
        クライアント証明書の有効期限が切れています
      </p>
      <p className="mt-1 text-red-800">
        kintoneへの接続を再開するには、組織の証明書を更新してください。
      </p>
      {onOpenSettings ? (
        <Button className="mt-3" variant="outline" onClick={onOpenSettings}>
          サービス利用・請求で証明書を更新
        </Button>
      ) : (
        <p className="mt-2 font-medium text-red-900">
          管理者に確認してください
        </p>
      )}
    </section>
  );
}
